var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('legend', [_vm._v("Day End Closure")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-tabs', {
    staticClass: "shipmentListtabInDayClosure",
    model: {
      value: (_vm.ActiveTabIndex),
      callback: function($$v) {
        _vm.ActiveTabIndex = $$v
      },
      expression: "ActiveTabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Shipment Reconciliation",
      "selected": true
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioButton),
      expression: "radioButton"
    }],
    attrs: {
      "type": "radio",
      "id": "SRradio",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.radioButton, "0")
    },
    on: {
      "click": function($event) {
        return _vm.SRTabData()
      },
      "change": function($event) {
        _vm.radioButton = "0"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "SRradio"
    }
  }, [_vm._v(" SR Closure ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioButton),
      expression: "radioButton "
    }],
    attrs: {
      "type": "radio",
      "id": "Agentradio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.radioButton, "1")
    },
    on: {
      "click": function($event) {
        return _vm.AgentTabData()
      },
      "change": function($event) {
        _vm.radioButton = "1"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "Agentradio"
    }
  }, [_vm._v(" Agent Closure ")])]), _vm._v(" "), (_vm.radioButton == 0) ? _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "top": "1em"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": _vm.srLoader
    }
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('basic-select', {
    attrs: {
      "placeholder": "Select SR",
      "options": _vm.srList,
      "selected-option": _vm.srItemObj,
      "name": "srId"
    },
    on: {
      "select": _vm.getSRs
    },
    model: {
      value: (_vm.srId),
      callback: function($$v) {
        _vm.srId = $$v
      },
      expression: "srId"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.radioButton == 1) ? _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "top": "1em"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": _vm.AgentsrLoader
    }
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.superagentsarray,
      "selected-option": _vm.agentitem,
      "placeholder": "Select Agent",
      "name": "Agent",
      "id": "Agent"
    },
    on: {
      "select": _vm.SelectAgent
    },
    model: {
      value: (_vm.Agent),
      callback: function($$v) {
        _vm.Agent = $$v
      },
      expression: "Agent"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.radioButton == 1) ? _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "top": "1em"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": _vm.srLoader
    }
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.AgentSRList,
      "selected-option": _vm.AgentSRObj,
      "name": "AgentSR",
      "placeholder": "Select SR"
    },
    on: {
      "select": _vm.selectDeliveryUser
    },
    model: {
      value: (_vm.AgentSR),
      callback: function($$v) {
        _vm.AgentSR = $$v
      },
      expression: "AgentSR"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('button', {
    staticClass: "btn btn-primary-outline",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Reload data"
    },
    on: {
      "click": function($event) {
        return _vm.Refreshdata()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading,
      "text": "Please wait"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "font-weight": "bold"
    },
    model: {
      value: (_vm.DayEndClosureBatchDateDiv),
      callback: function($$v) {
        _vm.DayEndClosureBatchDateDiv = $$v
      },
      expression: "DayEndClosureBatchDateDiv"
    }
  }, [(_vm.DayEndClosureBatchDate != '') ? _c('b', {
    attrs: {
      "show": _vm.DayEndClosureBatchDate != ''
    }
  }, [_vm._v("\n                                                    " + _vm._s(_vm.DayEndClosureBatchDate) + "\n                                                ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('strong', [_vm._v("Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('strong', [_vm._v("Total Allocated")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('strong', [_vm._v("Pending For SR Action")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('strong', [_vm._v("Fwd Delivered")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('strong', [_vm._v("Fwd Undelivered")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('strong', [_vm._v("RTO/DTO Delivered")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('strong', [_vm._v("RTO/DTO UnDelivered")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('strong', [_vm._v("RVP Picked Up")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('strong', [_vm._v("RVP Not Picked Up")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('strong', [_vm._v("Scanned")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('strong', [_vm._v("Lost")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('strong', [_vm._v("Status")])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.SRTable), function(item, index) {
    return _c('tr', {
      staticClass: "text-primary text-center"
    }, [_c('td', [_vm._v(_vm._s(item.Name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.Allocated))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.PendingForAction))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.FwdDelivered))]), _vm._v(" "), _c('td', {
      staticClass: "linkcolor",
      on: {
        "click": function($event) {
          return _vm.getDESShipmentDetails(item.DayEndClosureMasterID, false, item.FwdUnDelivered, ['Delivery'])
        }
      }
    }, [_vm._v(_vm._s(item.FwdUnDelivered))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.RTODTODelivered))]), _vm._v(" "), _c('td', {
      staticClass: "linkcolor",
      on: {
        "click": function($event) {
          return _vm.getDESShipmentDetails(item.DayEndClosureMasterID, false, item.RTODTOUnDelivered, ['RTO', 'DTO'])
        }
      }
    }, [_vm._v(_vm._s(item.RTODTOUnDelivered))]), _vm._v(" "), _c('td', {
      staticClass: "linkcolor",
      on: {
        "click": function($event) {
          return _vm.getDESShipmentDetails(item.DayEndClosureMasterID, false, item.RVPPickedUp, ['RVP'])
        }
      }
    }, [_vm._v(_vm._s(item.RVPPickedUp))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.RVPNotPickedUp))]), _vm._v(" "), _c('td', {
      staticClass: "linkcolor",
      on: {
        "click": function($event) {
          return _vm.getDESShipmentDetails(item.DayEndClosureMasterID, true, item.Scanned, null)
        }
      }
    }, [_vm._v(_vm._s(item.Scanned))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.Lost))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.Status))])])
  }), _vm._v(" "), (_vm.SRTable.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "35",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.csvLoadingFlag,
      "text": "Please wait"
    },
    on: {
      "update:active": function($event) {
        _vm.csvLoadingFlag = $event
      }
    }
  })], 1), _vm._v(" "), (_vm.scandiv) ? _c('div', {
    model: {
      value: (_vm.scandiv),
      callback: function($$v) {
        _vm.scandiv = $$v
      },
      expression: "scandiv"
    }
  }, [_c('form', {
    attrs: {
      "id": "ScanDayendClosureForm",
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm('form-1')
      }
    }
  }, [_c('div', {
    staticClass: "col-md-12 mb-4 mt-4"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('b-modal', {
    attrs: {
      "size": "vmd",
      "no-close-on-backdrop": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.bpidPopup),
      callback: function($$v) {
        _vm.bpidPopup = $$v
      },
      expression: "bpidPopup"
    }
  }, [_c('div', {
    staticClass: "custom-modal",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("BP ID Mismatch")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.closepopup()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm",
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.bpidShippintMismatch) ? _c('h5', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("You have scanned AWB instead of BPID ")]) : _vm._e(), _vm._v(" "), _c('h6', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" Please scan BPID barcode again ")]), _vm._v(" "), _c('p', [_vm._v(" (Scanned Value : " + _vm._s(_vm.brandPkgId) + " )")]), _vm._v(" "), _c('section', {
    staticClass: "modal-body",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "button-container"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.TryAgainCountofBrandedPkgId()
      }
    }
  }, [_vm._v("Scan Again")])])]), _vm._v(" "), (!_vm.bpidShippintMismatch) ? _c('p', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_vm._v("To continue with mismatched BP ID "), _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.AcceptBPID()
      }
    }
  }, [_vm._v(" click here..")])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" Shipment ID : ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingId),
      expression: "shippingId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    key: _vm.isAllowManualEntry,
    ref: "shippingId",
    class: {
      'form-control': true,
      'error': _vm.errors.has('shippingId')
    },
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "oncopy": "return false",
      "onpaste": "return false",
      "name": "shippingId",
      "id": "shippingId"
    },
    domProps: {
      "value": (_vm.shippingId)
    },
    on: {
      "change": function($event) {
        return _vm.validateForm('form-1')
      },
      "drop": _vm.handleDragOver,
      "keyup": _vm.KeyHandle,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shippingId = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.isAllowManualEntry == 1) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.shippingId')),
      expression: "errors.has('form-1.shippingId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" Please enter shipment no. ")]) : _vm._e()]), _vm._v(" "), (_vm.checkValue == 1 && _vm.isAllowManualEntry == 1) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Comments:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comments),
      expression: "comments"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.checkValue == '1' ? 'required': ''))),
      expression: "`${checkValue == '1' ? 'required': '' }`"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('comments')
    },
    attrs: {
      "name": "comments",
      "id": "comments"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.comments = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Comments")]), _vm._v(" "), _vm._l((_vm.commentsForManualEntry), function(comment_obj) {
    return _c('option', {
      domProps: {
        "value": comment_obj.text
      }
    }, [_vm._v(_vm._s(comment_obj.text))])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.comments')),
      expression: "errors.has('form-1.comments')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" Please Select comments ")])]) : _vm._e(), _vm._v(" "), (_vm.IsBrandPkgShip) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" BrandPkg ID : ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandPkgId),
      expression: "brandPkgId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    key: _vm.isAllowManualEntry,
    ref: "brandPkgId",
    class: {
      'form-control': true,
      'error': _vm.errors.has('brandPkgId')
    },
    attrs: {
      "type": "text",
      "name": "brandPkgId",
      "id": "brandPkgId",
      "autocomplete": "off",
      "oncopy": "return false",
      "onpaste": "return false"
    },
    domProps: {
      "value": (_vm.brandPkgId)
    },
    on: {
      "drop": _vm.handleDragOver,
      "keyup": _vm.KeyHandle,
      "change": function($event) {
        return _vm.ValidateBrandedPkgId()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.brandPkgId = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.isAllowManualEntry == 1) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.brandPkgId')),
      expression: "errors.has('form-1.brandPkgId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" Please enter branded packaging id. ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.comments),
      expression: "comments"
    }],
    staticClass: "col-md-8 mt-4"
  }, [_c('dummy-input', {
    ref: "dummyShipInputBox",
    staticClass: "mt-1",
    attrs: {
      "isDummyInput": _vm.isShowDummyInput,
      "duration": _vm.dummyInputTimeout,
      "styleData": _vm.styleData
    }
  })], 1), _vm._v(" "), _c('dummy-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.comments),
      expression: "!comments"
    }],
    ref: "dummyShipInputBox",
    staticClass: "col-md-8 mt-2",
    attrs: {
      "isDummyInput": _vm.isShowDummyInput,
      "duration": _vm.dummyInputTimeout,
      "styleData": _vm.styleData
    }
  }), _vm._v(" "), (_vm.NDRReasonData != '') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "top": "0.5em"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isNDRLoading,
      "text": "Please wait"
    },
    on: {
      "update:active": function($event) {
        _vm.isNDRLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('b-alert', {
    attrs: {
      "show": _vm.dismissCountDownSuccess,
      "dismissible": "",
      "fade": "",
      "variant": "success"
    },
    on: {
      "dismiss-count-down": _vm.countDownChangedSuccess
    }
  }, [_vm._v("\n                                                                          " + _vm._s(_vm.allocationSuccessMsg) + "\n                                                                      ")])], 1)])])], 1)]) : _vm._e()], 1), _vm._v(" "), (_vm.shippingId) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "title": "Scan data"
    }
  }, [_c('i', {
    staticClass: "fa fa-qrcode"
  }), _vm._v(" Submit")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.scanLoading,
      "text": "Please wait"
    },
    on: {
      "update:active": function($event) {
        _vm.scanLoading = $event
      }
    }
  })], 1), _vm._v("   \n                                                  "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-danger ml-2",
    attrs: {
      "type": "reset",
      "title": "Reload data"
    },
    on: {
      "click": function($event) {
        return _vm.Reset()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])]) : _vm._e()])])]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 card qcCheckPanel"
  }, [_c('legend', {
    staticClass: "mb-2"
  }, [_vm._v("Summary Table ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mb-2",
    staticStyle: {
      "padding-left": "5px",
      "padding-right": "5px"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading1,
      "text": "Please wait"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading1 = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('strong', [_vm._v("SR Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('strong', [_vm._v("Status")])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.SummaryTable), function(item, index) {
    return _c('tr', {
      staticClass: "text-primary text-center"
    }, [_c('td', [_vm._v(_vm._s(item.username))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.status))])])
  }), _vm._v(" "), (_vm.SummaryTable.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "35",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e()], 2)])], 1)])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "md",
      "data-toggle": "modal"
    },
    model: {
      value: (_vm.uploadMultipleImageModal),
      callback: function($$v) {
        _vm.uploadMultipleImageModal = $$v
      },
      expression: "uploadMultipleImageModal"
    }
  }, [_c('b-card', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Day End Closure - Upload Image\n                                    "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeuploadMultipleImageModal
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('b-form-fieldset', [_c('form', {
    attrs: {
      "action": "#",
      "method": "POST",
      "enctype": "multipart/form-data"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "file-upload col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "uploadImage1"
    }
  }, [_c('i', {
    staticClass: "fa fa-upload",
    attrs: {
      "title": "Upload Image",
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" Click to Upload Multiple Images")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("\n                                                    *")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    ref: "uploadImage1",
    class: {
      'form-control': true,
      'error': _vm.errors.has('uploadImage1')
    },
    attrs: {
      "id": "uploadImage1",
      "name": "uploadImage1",
      "type": "file",
      "multiple": ""
    },
    on: {
      "change": _vm.handleFileUpload
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clientnote col-md-12"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Note: Allowed File Format JPG,JPEG,PNG."), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Note: File Size Allowed Up to 5MB.\n                                        ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('uploadImage1')),
      expression: "errors.has('uploadImage1')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please upload image file.")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ClearuploadImageFile
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle-o"
  }), _vm._v(" Clear")])])])])], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vmd",
      "data-toggle": "modal"
    },
    model: {
      value: (_vm.GenerateBatchPopUpRVPQC),
      callback: function($$v) {
        _vm.GenerateBatchPopUpRVPQC = $$v
      },
      expression: "GenerateBatchPopUpRVPQC"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Error!")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.closepopup()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('section', {
    staticClass: "modal-body",
    staticStyle: {
      "text-align": "center",
      "font-size": "large",
      "color": "#070707"
    }
  }, [_vm._v("\n                                            No such Batch available for this SR, Please generate new batch.\n                                            "), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.Clickhere()
      }
    }
  }, [_vm._v("Click Here")])])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vmd",
      "no-close-on-backdrop": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.CloseBatchPopUp),
      callback: function($$v) {
        _vm.CloseBatchPopUp = $$v
      },
      expression: "CloseBatchPopUp"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Error!")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.closepopup()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('section', {
    staticClass: "modal-body",
    staticStyle: {
      "text-align": "center",
      "font-size": "large",
      "color": "#070707"
    }
  }, [_vm._v("\n                                            Previous batch is not closed for this user." + _vm._s(_vm.errormsg) + "\n                                            "), _c('div', {
    staticClass: "linkcolor",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "changeStatus"
    },
    on: {
      "click": function($event) {
        return _vm.Clickhere()
      }
    }
  }, [_vm._v("\"Click Here\"")])])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vmd",
      "no-close-on-backdrop": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.GenerateBatchPopUp),
      callback: function($$v) {
        _vm.GenerateBatchPopUp = $$v
      },
      expression: "GenerateBatchPopUp"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Error!")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.closepopup()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('section', {
    staticClass: "modal-body",
    staticStyle: {
      "text-align": "center",
      "font-size": "large",
      "color": "#070707"
    }
  }, [_vm._v("\n                                        No such Batch available for this user, Please generate new batch.\n                                        "), _c('div', {
    staticClass: "linkcolor",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.Clickhere()
      }
    }
  }, [_vm._v("\"Click Here\"")])])])])])])], 1)])], 1)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75576567","hasScoped":true}!./src/views/components/shipmentRecon/shipmentRecon.component.html
// module id = 1430
// module chunks = 1